
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//俄罗斯
export const lang ={
  Please_set_materialtype_in_product_page:"Перейдите на страницу продукта, чтобы изменить и установить тип материала каждого продукта — готовая продукция — полуфабрикаты — аксессуары.",
deleteAccount:"Выйти",
deleteAccountWillDeleteAllData:"Выход из вашей учетной записи удалит все данные и вы не сможете войти в систему.",
backupDatabase:"резервная база данных",
restoreDatabase:"Восстановить базу данных",
materialtype:"Тип материала",
Manufacturing:"Производственная версия",
Professional:"Профессиональная версия",
Standard:"Стандартная версия",
product:"Готовый продукт",
halfProduct:"Полуфабрикаты",
components:"Аксессуары",
Parent:"родительский компонент",
Children:"Дополнительные аксессуары",
Level:"Иерархия",
Timing:"Тайминг",
PieceCount:"Сдельная работа",
Wages:"Заработная плата",
InternalProcess:"Внутренний процесс",
ExternalProcess:"внешний процесс",
ProceName:"Имя процесса",
ProceIndex:"Порядок выполнения",
ChargeMan:"главный",
BillMethod:"Способ оплаты",
ConsumTime:"рабочее время",
Accessories:"Аксессуары",
Assembly:"Собрать",
materials:"материалы",
task:"Задача",
process:"процесс",
BOM:"спецификация",
Production:"Производство",
RestorePurchaseOneUse:"Восстановление покупки (один пользователь (ограничено предыдущими покупками))",
buy_fail_try_again:"Пожалуйста, нажмите еще раз, чтобы купить",
Export:"Экспорт",
Date:"дата",
BankDetail:"Банковские реквизиты",
Seller:"продавец",
Buver:"покупатель",
Currency:"валюта",
CompanyName:"Название компании",
ProformaInvoice:"счет-проформа",
Discount:"Скидка",
PayStatus:"Статус платежа",
ShippingStatus:"Статус отправки",
FreightType:"Тип транспорта",
Shipping:"груз",
Payment:"Оплата",
Moneyname:"название валюты",
Tax:"налоги",
Freight:"Стоимость фрахта",
Insurance:"страхование",
Bankfee:"банковские платежи",
Qc:"Сертификация качества",
Exchangerate:"обменный курс",
Shippingnumber:"номер отправления",
ShipDate:"Дата отправки",
Arrivedate:"Дата прибытия",
Grossweight:"вес брутто",
CubicWeight:"кубический вес",
Totalpackages:"Общее количество упаковок",
Moneytype:"тип валюты",
Quotedate:"дата котировки",
Validitydate:"Действительной датой",
Paymentterm:"истечение срока оплаты",
Priceterm:"условия ценообразования",
DeliveryTerm:"Срок поставки",
BankName:"название банка",
BankAddress:"Адрес банка",
SwiftCode:"Код банка",
Review:"Обзор",
Signfor:"Распишитесь о получении",
Finance:"финансы",
Receiver:"Получатель",
Business:"бизнес",
ContactPerson:"Контактное лицо",
Profit:"выгода",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"Сотрудники должны использовать Google Chrome. Пожалуйста, проверьте IP-адрес на странице справки приложения основного служебного компьютера, а затем введите адрес в столбце URL-адреса других компьютерных браузеров, чтобы открыть вход в систему.",
newPassword:"Новый пароль",
ForgetPassword:"забыть пароль",
ContactUs:"Свяжитесь с нами/предложите предложения",
Actualpay_should_big_then_shouldpay:"Фактические поступления не могут превышать дебиторскую задолженность.",
ShopAddress:"Адрес моего магазина Отсканируйте QR-код, чтобы оформить заказ",
Submit:"представлять на рассмотрение",
All:"все",
OrdernumExists:"Номер заказа уже существует",
PermissionDenied:"доступ запрещен",
StockTransfer:"Передача запасов",
FromWarehouse:"Вывоз со склада",
ToWarehouse:"Передача на склад",
PleaseUseInWebBrowser:"Пожалуйста, используйте функцию экспорта Excel в Google Chrome.",
PleasePrintInWebBrowser:"Пожалуйста, используйте функцию печати в Google Chrome.",
HistoryPrice:"историческая цена",
SerialNumber:"серийный номер",
Please_Use_In_APP:"Пожалуйста, используйте его в компьютерном программном обеспечении",
Please_Purchase_In_APP:"Пожалуйста, совершайте покупку в приложении, а не в браузере.",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Вы можете подключиться к базе данных Postgresql. Ваши данные будут храниться в базе данных Postgresql. По умолчанию вам не нужно подключаться к базе данных Postgresql. По умолчанию используется локальная база данных Sqlite.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Подключитесь к базе данных Postgresql, ваши данные будут сохранены в базе данных Postgresql, и данные будут прочитаны снова.",
Use_sqlite_data_will_store_in_local:"Используя sqlite, данные будут храниться на локальном компьютере.",
UsePostgresqlDatabase:"Использование базы данных PGSQL",
UseSqliteDatabase:"Использование базы данных Sqlite",
DatabaseName:"База данных имен",
Test_connect:"тестовое соединение",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Если у товара есть цвет или размер, для начального инвентаря введите 0. После добавления товара введите инвентарь в покупке.",
my:"мой",
my_shop_qrcode_scan:"QR-код моего магазина дает покупателям возможность сканировать код для размещения заказов. Мобильный телефон покупателя должен быть подключен к тому же маршрутизатору, что и ваш компьютер.",
ip:"ИП",
port:"Порт",
orderstatus:"Статус заказа",
image:"картина",
Template:"шаблон",
Please_select_a_excel_file:"Пожалуйста, выберите файл",
Please_select_only_one_excel_file:"Можно выбрать только один файл",
Connect_Internet_Login_again:"Подключитесь к Интернету и войдите снова перед покупкой.",

    productHasValidDate:'Продукт имеет действительный период',
productHasColor:'Продукт имеет размер цвета',
GeneralGoods:'Общие товары',
Selected:'выбранный',
RestorePurchase:'Возобновить покупку',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Постоянно покупайте Invoicing Enterprise Edition 1',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Покупка Invoicing Enterprise Edition не ограничена для пользователей и устройств',
Purchasing:'Покупка ... Пожалуйста, подождите терпеливо ...',
Validdate:'Срок действия',
Makedate:'Дата изготовления',
Batch:'партия',
CheckVersion:'Проверить версию',
Please_set_this_ip_address_on_App:'Пожалуйста, установите этот IP-адрес или IP-адрес компьютера в приложении.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Откройте это соединение на вашем компьютере или в мобильном браузере (подключите тот же WiFi)',


CheckVersion:'Проверить версию',
You_need_to_purchase:'Вы еще не купили, пожалуйста, добавьте WeChat в Elink9988 E-mail: bvbuy@qq.com',
Thank_for_your_purchase:'Вы уже купили',
New_version_available:'Есть новая версия',
Is_the_latest_version:'это последняя версия',
please:'пожалуйста',
input:'вход',
wrong:'неправильно',
Verifycode:'Проверить код',
Upload:'Загрузить',
Download:'Скачать',
You_need_to_purchase_to_continue_use:'Вам необходимо приобрести, чтобы продолжить использование',
CheckBuy:'Проверить покупку',
Exists:'Существует',
NetworkUnavailable:'Сеть недоступна',
Today:'сегодня',
Yesterday:'Вчера',
ThisMonth:'Этот месяц',
LastMonth:'Прошлый месяц',
nickname:'прозвище',
storeName:'название магазина',
BuyStandAlone:'купить автономную версию',
PermissionDenied:'Доступ запрещен',
Boss:'босс',

    login:'Авторизоваться',
operate:'работать',
register:'регистр',
username:'Имя пользователя',
password:'пароль',
User:'пользователь',
ok:'Хорошо',
back:'назад',
success:'успех',
fail:'Потерпеть поражение',
cancel:'отменить',
add:'добавлять',
edit:'редактировать',
delete:'удалять',
refresh:'обновление',
close:'близко',
cancel:'отменить',
return:'Вернуть',
ElinkInvoice:'Elink Invoice',
Purchase:'покупка',
BaseData:'База данных',
Sell:'продавать',
PurchaseReturns:'возврат товара',
SellReturns:'Продать возврат',
Inventory:'инвентарь',
Statistics:'Статистика',
Receivable:'дебиторов',
Payable:'к оплате',
Orders:'заказы',
StockTransfer:'Передача акций',
StockRecall:'Отзыв на складе',
Customer:'Покупатель',
Supplier:'поставщик',
Warehouse:'Склад',
Color:'цвет',
Size:'Размер',
Category:'категория',
Category2:'Категория2',
Product:'Товар',
Account:'учетная запись',
AccountType:'Категория аккаунта',
Staff:'Штат сотрудников',
typeone:'категория',
typetwo:'Подкатегория',
ProductName:'Наименование товара',
Specification:'Спецификация',
Barcode:'Штрих-код',
Buyprice:'Цена покупки',
Sellprice:'Цена продажи',
Wholesaleprice:'Оптовая цена',
Currentstock:'Токи ток',
Unit:'Единица измерения',
Initstock:'Начальная акция',
Parameter:'параметр',
Remark:'замечание',
Supplier:'поставщик',
Customer:'Покупатель',
Staff:'Штат сотрудников',
Receivable:'дебиторов',
payable:'к оплате',
Receipts:'поступления',
Paid:'оплаченный',
Preferential:'преимущественный',
DateDay:'Дата',
OrderNum:'Порядковый номер',
Name:'название',
UserName:'Имя пользователя',
IdNum:'Идентификационный номер',
BirthDay:'день рождения',
SEX:'секс',
Female:'женский',
Male:'мужчина',
Select:'Выбрать',
Address:'Адрес',
Phone:'Телефон',
Email:'Эл. адрес',
CardNum:'Номер карты',
Price:'Цена',
QTY:'Кол-во',
SupplierCategory:'Категория поставщика',
CustomerCategory:'Категория клиентов',
Power:'Мощность',
Role:'Роль',
save:'Сохранить',
image:'образ',
search:'Поиск',
Year:'Год',
Month:'Месяц',
Day:'День',
Total:'Всего',
WorkReport:'Отчет о работе',
Leave:'Покидать',
CheckIn:'Регистрироваться',
Announcement:'Объявление',
Approval:'утверждение',
Tracking:'отслеживание',
Bill:'Билл',
OrdersDetail:'Детали заказов',
Expense:'расходы',
Income:'доход',
Userfor:'Userfor',
Amount:'Количество',
Title:'заглавие',
News:'Новости',
SelectFile:'Выберите файл',
Content:'содержание',
Cost:'Стоимость',
ApprovalUser:'Пользователь Одобрения',
ApprovalStatus:'Статус одобрения',
ApprovalRemark:'Подтверждение Примечание',
ApprovalDate:'Дата утверждения',
SubmitDate:'Дата отправки',
Status:'Статус',
FromDateTime:'С даты время',
ToDateTime:'На сегодняшний день Время',
Subject:'Предмет',
Latitude:'широта',
Longitude:'Долгота',
Print:'Распечатать',
DataTrans:'DataTrans',
OA:'О.А.',
Setting:'настройка',
Help:'Помогите',
ScanOpenInPhone:'Сканирование Открыть в телефоне',
Building:'Строительство',
Room:'Номер',
HotelCheckIn:'Регистрироваться',
CheckOut:'Проверять, выписываться',
Hotel:'Гостиница',
Checkintime:'Время заезда',
Checkouttime:'Время выезда',
Deposit:'депозит',
Cost:'Стоимость',
RoomNum:'Номер комнаты',
Rent:'Арендная плата',
costday:'costday',
rent:'арендная плата',
waternum:'Водная степень',
electricnum:'Электрическая степень',
gasnum:'Степень газа',
watercost:'стоимость воды',
electriccost:'стоимость электроэнергии',
gascost:'стоимость газа',
cleaningcost:'стоимость уборки',
networkcost:'стоимость сети',
tvcost:'стоимость телевизора',
managecost:'управлять стоимостью',
othercost:'прочие расходы',
totalcost:'Общая стоимость',
remark:'замечание',
addtime:'добавить время',
OpenInBrowser:'Открыть в браузере',
InventoryProfit:'Товарно-материальная прибыль',
InventoryLoss:'Потеря инвентаря',
Buy:'купить',



Refresh:'Обновить',
Add:'Добавить',
Search:'Поиск',
Records:'записей',
}



// WEBPACK FOOTER //
// ./src/lang/ru.js